import '../App.css';
import '../styles/discordLogin.css';
import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Cookies from 'js-cookie'
import  { Redirect, Route } from 'react-router-dom'

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';


class discordLogin extends React.Component {

  constructor(props) {
    super(props);

    console.log(this.props);
    // If there is a props location state -> then set it equal to the state of the user, if not set user to null
    // There will be a props.location.state.user if this page was called by callback.js ->
    // meaning the user is re-logging in manually, or logging in for the first time 
    this.state = {
      user: (this.props.location.state === undefined) ? null: this.props.location.state.user,
      redirect: false,
      login_url: null,
      account_deleted: false
    }

    // Declare functions
    this.deleteAccount = this.deleteAccount.bind(this);
    this.logout = this.logout.bind(this);

  }

  logout() {
    console.log("Logging out...");
    this.setState( {redirect: true} );
  }

  async deleteAccount() {
    let proceed = window.confirm("Are you sure you want to delete your account? (all your data will be lost)");
    if (proceed) {
      console.log("Deleting account...")
      // NOTE: USE Web version 9 examples from firebase website
      // NOTE: Not Needed since the above response gives back all of the users data needed 
      const firebase = require('firebase/app')
      const firestore = require('firebase/firestore')

      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      const firebaseConfig = {
        apiKey: "AIzaSyDrtmhqEuoRjfnE1QCRdeYG6qlc7FAqIfk",
        authDomain: "gym-bro-discord-bot.firebaseapp.com",
        //databaseURL: "https://gym-bro-discord-bot-default-rtdb.firebaseio.com", // Real-time database
        projectId: "gym-bro-discord-bot"
        //storageBucket: "gym-bro-discord-bot.appspot.com",
        //messagingSenderId: "199430379675",
        //appId: "1:199430379675:web:406bf36a6f4496ef450e3e",
        //measurementId: "G-S9G1V79BPR"
      };
      // Initialize the Firebase app
      const app = firebase.initializeApp(firebaseConfig);
      // Connect to the Firestore Database 
      const db = firestore.getFirestore();
      //const db = firebase.firestore();
      const res = await firestore.deleteDoc(firestore.doc(db, "users", this.state.user.discord_user_data.id))
      this.setState( {account_deleted: true} );
    }
    else {
      alert("Cancelled")
    }
  }

  // NOTE: To retrieve the image it is: https://cdn.discordapp.com/avatars/{discord_user_id}/{avatar_hash}
  async componentDidMount() {
    // TODO: Have a check to make sure that a user exists on this page 

    // If the user is already logged in, this will activate 
    if (this.state.user === null) {
      
      // Get the refresh token 
      let refresh_token = Cookies.get('refresh_token');
      // For testing:
      //let refresh_token = "cunt"
      // Call the function login_user that will automatically refresh the data of the user using the refresh token
      const login_url = "/.netlify/functions/login_user?refresh_token=" + refresh_token;
      const site = "https://gym-bro-bot.netlify.app";

      let user_data = null;
      try {
        let response = await fetch(site + login_url);
        user_data = await response.json();
        //console.log(user_data)
      }
      catch(err) {
        console.log("FAILED AUTO LOGIN")
        //console.log(err);
        // Set cookies back to null and false
        Cookies.set('access_token', null);
        Cookies.set('refresh_token', null);
        Cookies.set('isAuthenticated', false);
        // And then redirect back to the url to re-login
        // GET method: get the url for the request in order for the user to login and accept the scopes
        this.setState( {redirect: true} );
        return;
      }

      this.setState( {user: user_data} );

    }

    //console.log("SHOULD NOT BE HERE WTF IS IT DOING HERE")

    let discord_data = this.state.user.discord_user_data
    // Set the cookies to keep track of the access and refresh token
    // so the user doesn't have to login everytime to access this page
    Cookies.set('access_token', discord_data.access_token);
    Cookies.set('refresh_token', discord_data.refresh_token);
    Cookies.set('isAuthenticated', true);

    console.log("USER DATA: ", this.state.user);
    //console.log(`${this.state.cdn_url}avatars/${this.state.user.id}/${this.state.user.avatar}`)
  }

  render() {

    // If it failed to login the user, redirect to the login url for user to re-login
    if (this.state.redirect) {
      console.log("Redirecting...");
      return (
        <Route render={() => <Redirect push to="/" />} />
      );
    }

    if (this.state.account_deleted) {
      console.log("Redirecting to account delete page");
      return (
        <Route render={() => <Redirect push to="/accountDeleted" />} />
      );
    }
    
    //console.log("HERE");

    const cdn_url = "https://cdn.discordapp.com/";
    
    let pfp, username, bench_pr, squat_pr, deadlift_pr, weight, gym_playlist, gym_idol;
    // If the user is not set yet
    if (this.state.user === null) {
      pfp = <img className='profile_pic' src="" alt="Discord Profile"/>;
      username = "";
      bench_pr = "";
      squat_pr = "";
      deadlift_pr = "";
      weight = "";
      gym_playlist = "";
      gym_idol = "";
    }
    // If a user exists
    else {
      let discord_data = this.state.user.discord_user_data
      let stat_data = this.state.user.stat_data
      let misc_data = this.state.user.misc
      pfp = <img className="profile_pic" src={`${cdn_url}avatars/${discord_data.id}/${discord_data.avatar}`} alt="Discord Profile"/>;
      username = <h2>{`${discord_data.username}#${discord_data.discriminator}`}</h2>;

      bench_pr = <h3>{`Bench PR: ${stat_data.bench.max_weight} lbs for ${stat_data.bench.reps} for rep(s)`}</h3>;
      squat_pr = <h3>{`Squat PR: ${stat_data.squat.max_weight} lbs for ${stat_data.squat.reps} for rep(s)`}</h3>;
      deadlift_pr = <h3>{`Deadlift PR: ${stat_data.deadlift.max_weight} lbs for ${stat_data.deadlift.reps} for rep(s)`}</h3>;

      weight = <h3>{`Weight: ${stat_data.weight} lbs`}</h3>;

      gym_playlist = <h4><a href={`${misc_data.gym_playlist}`} target="_blank">Gym Playlist</a></h4>
      gym_idol = <h4>{`Gym Idol: ${misc_data.gym_idol}`}</h4>
    }

    return (
      <div className="App">
        <Navbar />

        <header className="Settings-header">
          <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
          <React.Fragment>
          <Button variant="contained" {...bindTrigger(popupState)}>
          Settings
          </Button>
          <Menu {...bindMenu(popupState)}>
          <MenuItem onClick={this.logout}>Logout</MenuItem>
          <MenuItem onClick={this.deleteAccount}>Delete Account</MenuItem>
          </Menu>
          </React.Fragment>
          )}
          </PopupState>
        </header>

        <header className="App-header">

          {pfp}
          {username}
          <h2>Stats:</h2>
          <ul>
            {bench_pr}
            {squat_pr}
            {deadlift_pr}
            {gym_playlist}
            {gym_idol}
          </ul>

          
          <br></br>
          <br></br>



        </header>



      </div>
    );
  }

}

export default discordLogin;




// For reference: 
/*
// NOTE: Not Needed since the above response gives back all of the users data needed 
const firebase = require('firebase/app')
const firestore = require('firebase/firestore')

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDrtmhqEuoRjfnE1QCRdeYG6qlc7FAqIfk",
  authDomain: "gym-bro-discord-bot.firebaseapp.com",
  //databaseURL: "https://gym-bro-discord-bot-default-rtdb.firebaseio.com", // Real-time database
  projectId: "gym-bro-discord-bot"
  //storageBucket: "gym-bro-discord-bot.appspot.com",
  //messagingSenderId: "199430379675",
  //appId: "1:199430379675:web:406bf36a6f4496ef450e3e",
  //measurementId: "G-S9G1V79BPR"
};
// Initialize the Firebase app
const app = firebase.initializeApp(firebaseConfig);
// Connect to the Firestore Database 
const db = firestore.getFirestore();

const user_doc_ref = firestore.doc(db, "users", .id);
const get_doc = await firestore.getDoc(user_doc_ref);
let user_data = get_doc.data()
this.setState( {user: user_data} );

const login_url = "/.netlify/functions/login_user?refresh_token=" + this.state.user.discord_user_data.refresh_token;
const site = "https://gym-bro-bot.netlify.app";
let response = await fetch(site + login_url);
user_data = await response.json();
console.log(user_data)
*/


